import type { FrameInfoV2 } from '@microsoft/wv2-outlook/instanceIframeTracker';
import { getScenarioFromIframeSource } from './iframeScenarioUtils';
import type { IframeScenario } from '../settings/iframes-mapping';

export function prettyPrintFrameInfos(
    frameInfos: FrameInfoV2[],
    scenario?: IframeScenario,
    filterOnlyScenario?: boolean
): string {
    if (!scenario) {
        return frameInfos.map(formatFrameInfo).join('\n');
    }

    const matchesScenario = (f: FrameInfoV2) =>
        getScenarioFromIframeSource(f.iframeSource) === scenario;

    if (filterOnlyScenario) {
        return frameInfos.filter(matchesScenario).map(formatFrameInfo).join('\n');
    }

    // Sort matching scenario first
    return [...frameInfos]
        .sort((a, b) => Number(matchesScenario(b)) - Number(matchesScenario(a)))
        .map(formatFrameInfo)
        .join('\n');
}

function formatFrameInfo(frameInfo: FrameInfoV2): string {
    return `FrameInfo {
    scenario: ${getScenarioFromIframeSource(frameInfo.iframeSource)},
    src: ${frameInfo.iframeSource},
    nativehost_id: ${frameInfo.iframeId},
    nativehost_pid: ${frameInfo.processId},
    correlationId: ${frameInfo.correlationId},
    workingSetSize: ${frameInfo.workingSetSize}MB,
    commitSize: ${frameInfo.commitSize}MB,
}`;
}
